import { ReactNode } from 'react';
import { useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { tokens, Caption1 } from '@fluentui/react-components';
import { Sidebar } from './Sidebar';
import { TopBar } from './TopBar';
import { TrialBanner } from './TrialBanner';
import { FloatingNewsWidget } from './FloatingNewsWidget';
import { AnnouncementsPopup } from './AnnouncementsPopup';

interface LayoutProps {
  children: ReactNode;
}

export function Layout({ children }: LayoutProps) {
  const location = useLocation();
  const { t } = useTranslation();

  const selected =
    location.pathname.startsWith('/controls')   ? 'controls'   :
    location.pathname.startsWith('/cyfun')      ? 'cyfun'      :
    location.pathname.startsWith('/compliance') ? 'compliance' :
    location.pathname.startsWith('/azure')      ? 'azure'      :
    location.pathname.startsWith('/scans')      ? 'scans'      :
    location.pathname.startsWith('/reports')    ? 'reports'    :
    location.pathname.startsWith('/alerts')     ? 'alerts'     :
    location.pathname.startsWith('/tenants')    ? 'tenants'    :
    location.pathname.startsWith('/partners')   ? 'partners'   :
    location.pathname.startsWith('/users')      ? 'users'      :
    location.pathname.startsWith('/billing')    ? 'billing'    :
    location.pathname.startsWith('/license')    ? 'license'    :
    location.pathname.startsWith('/settings')   ? 'settings'   :
    location.pathname.startsWith('/onboarding') ? 'onboarding' :
                                                  'dashboard';

  return (
    <div
      style={{
        display:         'flex',
        minHeight:       '100vh',
        backgroundColor: tokens.colorNeutralBackground1,
      }}
    >
      <Sidebar selected={selected} />
      {/* v2026.06.111 - minWidth:0 critique pour eviter overflow horizontal.
          Sans ca, un flex-item peut deborder son parent si son contenu interne
          est plus large (cas CyFun avec barre d actions longue). */}
      <div style={{
        flex:            1,
        minWidth:        0,
        display:         'flex',
        flexDirection:   'column',
        marginLeft:      48,
        paddingRight:    48,
        backgroundColor: tokens.colorNeutralBackground1,
      }}>
        <TopBar />
        <TrialBanner />
        <main style={{
          flex:     1,
          minWidth: 0,
          padding:  '32px 0',
          overflow: 'auto',
        }}>
          {/* v2026.06.159 - Popup news/announcements à la connexion */}
          <AnnouncementsPopup />
          {children}
        </main>
        <footer
          style={{
            backgroundColor: '#142939',
            color:           '#B4C4D4',
            padding:         '14px 24px',
            display:         'flex',
            justifyContent:  'space-between',
            alignItems:      'center',
            gap:             16,
            flexWrap:        'wrap',
            borderTop:       'none',
          }}
        >
          <Caption1 style={{ color: '#B4C4D4' }}>
            {t('footer.copyright')}
          </Caption1>
          <Caption1 style={{ color: '#B4C4D4' }}>
            <a
              href="https://nis365.eu"
              target="_blank"
              rel="noopener noreferrer"
              style={{
                color:          '#fff',
                textDecoration: 'none',
                fontWeight:     600,
              }}
            >
              nis365.eu →
            </a>
            <span style={{ color: '#7B8FA3' }}>
              ·
            </span>
            <Caption1 style={{ color: '#B4C4D4' }}>
              v2026.06
            </Caption1>
          </Caption1>
        </footer>
      </div>
    </div>
  );
}
